module.exports = __webpack_public_path__ + "img/Jump Screenshoot (0-00-09-06)_23.95bd6727.jpg";